import { useSearchParams, Link } from 'react-router-dom';
import Navbar from './Navbar/Navbar';
import Footer from './Footer';
import './ContributorResponsePage.scss';

const ContributorResponsePage = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const message = searchParams.get('message');

  const isSuccess = status === 'recorded';
  const isError = status === 'error';

  return (
    <div className="contributor-response-page">
      <Navbar />
      <div className="contributor-response-page__content">
        <div className="contributor-response-page__card">
          {isSuccess && (
            <>
              <h1 className="contributor-response-page__title">Thank You</h1>
              <p className="contributor-response-page__message">
                Thank you for your response. Your contribution helps the community.
              </p>
              <p className="contributor-response-page__sub">
                Jazakallah Khair for being part of Chorullapalli.
              </p>
            </>
          )}
          {isError && (
            <>
              <h1 className="contributor-response-page__title contributor-response-page__title--error">
                Something went wrong
              </h1>
              <p className="contributor-response-page__message">
                {message === 'invalid_token'
                  ? 'This link may have expired or is invalid. Please request a new email.'
                  : message === 'missing_params'
                  ? 'Invalid link. Please use the link from your email.'
                  : 'We could not process your response. Please try again later.'}
              </p>
            </>
          )}
          {!isSuccess && !isError && (
            <>
              <h1 className="contributor-response-page__title">Contributor Response</h1>
              <p className="contributor-response-page__message">
                Please use the link from your email to submit your availability.
              </p>
            </>
          )}
          <Link to="/" className="contributor-response-page__link">
            Back to Home
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContributorResponsePage;
